export default __webpack_public_path__ + "ba8a3775ced8d93114a8de9da56b78e5.png";